// Wraps keyword-syntax operators in highlight spans so they stand out in keyword text. Shared by
// the keywords page (Keyword.vue) and the tenders keywords drawer so the highlighting is identical.
// Operators: ignored ![...] , inclusion ?[...] , asterisk * , ampersand & , tilde ~ .
// The returned string is injected via v-html; the .keyword__* colour classes style each span.
export function highlightKeywordSyntax(text) {
  // Escape HTML first — the result is injected via v-html, and keyword values are user-entered, so
  // an unescaped `<...>` would run as markup (stored XSS). `&` must be escaped before `<`/`>`, and
  // the ampersand operator below then matches the escaped `&amp;`.
  let keyword = (text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // highlight ignored chunks
  keyword = keyword.replace(/!\[.*?\]/g, (str) => "<span class='keyword__ignored'>" + str + '</span>');

  // highlight inclusions chunks
  keyword = keyword.replace(/\?\[.*?\]/g, (str) => "<span class='keyword__inclusion'>" + str + '</span>');

  // highlight asterisk
  keyword = keyword.replaceAll(/\*(\[\d+\])?/g, (str) => "<span class='keyword__asterisk'>" + str + '</span>');

  // highlight ampersand (escaped to &amp; above)
  keyword = keyword.replaceAll(/&amp;(\[\d+\])?/g, (str) => "<span class='keyword__ampersand'>" + str + '</span>');

  // highlight tild
  keyword = keyword.replaceAll('~', (str) => "<span class='keyword__tild'>" + str + '</span>');

  return keyword;
}
